import fetchStatesBuilder from './fetchStates/fetchStates';
import Translator from '../../../infrastructure/Translator';

export default {
  fetchStates: fetchStatesBuilder(new Translator()),
};
